// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dark-mode {
  --background-color0: #19191e;
  --background-color1: #24242b;
  --background-color2: #38383E;

  --accent-color0: #0945cb;
  --accent-color1: #0487e4;
  --accent-color2: #04b8f4;
  --accent-color3: #ff4500;
  --accent-color4: #ff6a33;
  
  --text-color0: #d4d2d2;
  --text-color1: #e6e6e6;
  --text-color2: #f2f1f6;

  --navbar-color: rgba(36, 36, 43, 0.96);
}

.white-mode {
  --background-color0: #fff;
  --background-color1: #f2f1f6;
  --background-color2: #e6e6e6;

  --accent-color0: #0945cb;
  --accent-color1: #0487e4;
  --accent-color2: #04b8f4;
  --accent-color3: #ff4500;
  --accent-color4: #ff6a33;

  --text-color0: #232c33;
  --text-color1: #394147;
  --text-color2: #4f565c;

  --navbar-color: rgba(255, 255, 255, 0.96);

  --white-img-brighness: 0.3;
  --white-img-opacity: 0.3;
}`, "",{"version":3,"sources":["webpack://./src/theme.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;;EAE5B,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;;EAExB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;;EAEtB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,4BAA4B;;EAE5B,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;;EAExB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;;EAEtB,yCAAyC;;EAEzC,0BAA0B;EAC1B,wBAAwB;AAC1B","sourcesContent":[".dark-mode {\r\n  --background-color0: #19191e;\r\n  --background-color1: #24242b;\r\n  --background-color2: #38383E;\r\n\r\n  --accent-color0: #0945cb;\r\n  --accent-color1: #0487e4;\r\n  --accent-color2: #04b8f4;\r\n  --accent-color3: #ff4500;\r\n  --accent-color4: #ff6a33;\r\n  \r\n  --text-color0: #d4d2d2;\r\n  --text-color1: #e6e6e6;\r\n  --text-color2: #f2f1f6;\r\n\r\n  --navbar-color: rgba(36, 36, 43, 0.96);\r\n}\r\n\r\n.white-mode {\r\n  --background-color0: #fff;\r\n  --background-color1: #f2f1f6;\r\n  --background-color2: #e6e6e6;\r\n\r\n  --accent-color0: #0945cb;\r\n  --accent-color1: #0487e4;\r\n  --accent-color2: #04b8f4;\r\n  --accent-color3: #ff4500;\r\n  --accent-color4: #ff6a33;\r\n\r\n  --text-color0: #232c33;\r\n  --text-color1: #394147;\r\n  --text-color2: #4f565c;\r\n\r\n  --navbar-color: rgba(255, 255, 255, 0.96);\r\n\r\n  --white-img-brighness: 0.3;\r\n  --white-img-opacity: 0.3;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
